import dayjs from 'dayjs';

const DATE_INI_CALCOLATE_DBINDEX = "01/01/2000"
//const DATE_INI_CALCOLATE_DBINDEX = "12/31/1999"

export const getGiornoDellAnno = (data) =>{

  data.setHours(0);
  data.setMinutes(0);
  data.setSeconds(0);

  const inizioAnno = new Date(data.getFullYear(), 0, 1);
  inizioAnno.setHours(0);
  inizioAnno.setMinutes(0);
  inizioAnno.setSeconds(0);
  
  const differenza = data - inizioAnno;
  const millisecondiInUnGiorno = 1000 * 60 * 60 * 24;
  return Math.floor(differenza / millisecondiInUnGiorno) + 1;
}

export const getNumberOfDays = (start, end) => {
    const date1 = new Date(start);
    const date2 = new Date(end);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = date2.getTime() - date1.getTime();

    // Calculating the nr. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays;
}

export const getIndexOfDaysDb = (dayInDaysjFormat, correction) => {  
    let index= Number(dayInDaysjFormat.format('YYYY'))*10000+Number(dayInDaysjFormat.format('MM'))*100+Number(dayInDaysjFormat.format('DD'));
    return index;
}

export const getIndexOfDaysDbMillis = (end, correction) => {
    const date1 = new Date(DATE_INI_CALCOLATE_DBINDEX);
    const date2 = new Date(end);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = date2.getTime() - date1.getTime();

    // Calculating the nr. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay)+correction;

    return diffInDays;
}


export const getNumberOfWeek = (day) => {
    const d = new Date(day);
    d.setHours(0,0,0,0);
    d.setDate(d.getDate() + 4 - (d.getDay()||7));
    const yearStart = new Date(d.getFullYear(),0,1);
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1)/7);
    return weekNo;
}

export const getHoursAndMinutesStringFromMinutes = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  let hoursString = hours.toString();
  //if (hours<10) hoursString= '0'+hoursString;
  let  minutesString = minutes.toString();
  if (hours<10) hoursString = '0'+hoursString;
  if (minutes<10) minutesString = '0'+minutesString;
  const hourMinutesString= hoursString+':'+minutesString;
  //console.log("hours=", hours);
  //console.log("minutes=", minutes);
  //console.log("hours.toString=", hours.toString());
  //console.log("minutes.toString=", minutes.toString());
  //console.log("hourMinutesString=",hourMinutesString );
  return { hourMinutesString };
}

